<template>
    <div>
        <!-- A2P Brand Errors -->
        <div v-if="row.errors && row.errors.length > 0 && isA2pBrand">
            <p
                v-for="error in row.errors"
                :key="error.error_code"
                class="mb-0"
            >
                <span class="font-weight-bold">Error Code {{ error.registrationerrorcode }}:</span> {{ fixToUcFirst(error.registrationerrorfields[0]) }} - {{ error.registrationerrordescription }}
            </p>
        </div>

        <!-- A2P Campaign Errors -->
        <div v-else-if="row.errors && row.errors.length > 0 && isA2pCampaign">
            <p
                v-for="error in row.errors"
                :key="error.error_code"
                class="mb-0"
            >
                <span class="font-weight-bold">Error Code {{ error.error_code }}:</span> {{ fixToUcFirst(error.fields[0]) }} - {{ error.description }}
            </p>
        </div>

        <!-- Toll-Free Verification Errors -->
        <div v-else-if="isTollFreeVerification && (row.rejection_reasons || row.error_code || row.rejection_reason)">
            <!-- First check for rejection_reasons array -->
            <div v-if="row.rejection_reasons && row.rejection_reasons.length > 0">
                <p 
                    v-for="(reason, index) in row.rejection_reasons" 
                    :key="`reason-${index}`" 
                    class="mb-0"
                >
                    <span class="font-weight-bold">Error Code {{ reason.code }}:</span> {{ reason.reason }}
                </p>
            </div>
            <!-- Fall back to old implementation if rejection_reasons is empty -->
            <div v-else-if="row.error_code || row.rejection_reason">
                <p class="mb-0">
                    <span class="font-weight-bold">Error Code {{ row.error_code }}:</span> {{ row.rejection_reason }}
                </p>
            </div>
        </div>

        <!-- Standard Failure Reasons -->
        <span v-else-if="row.failure_reason">{{ row.failure_reason }}</span>
        <span v-else>-</span>
    </div>
</template>

<script>
import { compliance_mixin } from '../../../mixins'

export default {
    name: 'FailureReasonColumn',
    mixins: [compliance_mixin],
    props: {
        row: {
            type: Object,
            required: true
        },
        isA2pBrand: {
            type: Boolean,
            default: false
        },
        isA2pCampaign: {
            type: Boolean,
            default: false
        },
        isTollFreeVerification: {
            type: Boolean,
            default: false
        },
    },
}
</script>
